import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { getRefreshAge } from '../../utils/dateUtils';
import { buildStaleDataStripCopy } from './staleDataStripUtils';
import type { StaleDataStripCopy } from './types';

export function useStaleDataStrip(): StaleDataStripCopy | null {
    const params = useParams();
    const refreshNudge = useAppSelector((state) => state.investor.refreshNudge);

    return useMemo(() => {
        if (refreshNudge?.status !== 'loaded' || refreshNudge.orgId !== params.id || !refreshNudge.showNudge) return null;
        const { lastRefreshedAt } = refreshNudge;
        if (typeof lastRefreshedAt !== 'number' || lastRefreshedAt <= 0) return null;
        const age = getRefreshAge(lastRefreshedAt);
        return age ? buildStaleDataStripCopy(age, lastRefreshedAt) : null;
    }, [refreshNudge, params.id]);
}
